"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AUTOMATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AUTOMATION;
  }
});
Object.defineProperty(exports, "CENTRAL_DATABASE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CENTRAL_DATABASE;
  }
});
Object.defineProperty(exports, "CONTENT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTENT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CRM", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CRM;
  }
});
Object.defineProperty(exports, "CROSS_CHANNEL_FULFILLMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CROSS_CHANNEL_FULFILLMENT;
  }
});
Object.defineProperty(exports, "EMAIL_MARKETING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EMAIL_MARKETING;
  }
});
Object.defineProperty(exports, "INVENTORY_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INVENTORY_MANAGEMENT;
  }
});
Object.defineProperty(exports, "ORDER_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ORDER_MANAGEMENT;
  }
});
Object.defineProperty(exports, "PRODUCT_VISUALIZATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PRODUCT_VISUALIZATION;
  }
});
Object.defineProperty(exports, "REPORTING_ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.REPORTING_ANALYTICS;
  }
});
Object.defineProperty(exports, "RETURNS_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.RETURNS_MANAGEMENT;
  }
});
Object.defineProperty(exports, "REVIEWS_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.REVIEWS_MANAGEMENT;
  }
});
Object.defineProperty(exports, "SEARCH_FUNCTION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SEARCH_FUNCTION;
  }
});
Object.defineProperty(exports, "SEO", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SEO;
  }
});
Object.defineProperty(exports, "STOREFRONT_DESIGN_TOOLS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.STOREFRONT_DESIGN_TOOLS;
  }
});
Object.defineProperty(exports, "THIRD_PARTY_STORE_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.THIRD_PARTY_STORE_INTEGRATION;
  }
});
Object.defineProperty(exports, "UNIFIED_CUSTOMER_EXPERIENCE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.UNIFIED_CUSTOMER_EXPERIENCE;
  }
});
Object.defineProperty(exports, "WEBSITE_BUILDER", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.WEBSITE_BUILDER;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/ECommerce.js
// module id = 567
// module chunks = 209 210 211 212 213